// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"144":"63a317f4","724":"a1d73d88","902":"46ccdcd4"}[chunkId] + ".css";
};